<div class="row align-items-center p-b-10 d-none">
  <div class="col-sm-12 col-lg-12">
    <div class="d-flex align-items-center flexmob">
      <div class="m-l-10 d-flex align-items-center">
        <!--<div>
          <button mat-fab style="width: 50px;height: 50px;border-radius: 20%;" class="brandbglight">
            <i-tabler name="report" class="icon-28" style="line-height: 30px !important"></i-tabler>
          </button>
        </div>-->
        <div class="m-l-10">
          <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
            Trustees' Report
          </h4>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row align-items-center m-b-10">
  <div class="col-sm-12 col-lg-6">

    <div class="d-flex align-items-center flexmob">

      <div class="d-flex align-items-center f-s-14 text-black-25 border-right p-r-10 cursor-pointer f-w-600" (click)="backToCharityOverView()">
        <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-left"></i-tabler> Back to Charity Overview
      </div>
      <div class="m-l-10 d-flex align-items-center">

        <div class="m-l-10">
          <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
            Trustees' Report
          </h4>
        </div>
      </div>


    </div>
  </div>
  <div class="col-sm-12 col-lg-6  text-end">

    <div class="d-flex align-items-center justify-content-end">


    </div>
  </div>
</div>


<!--Period Finalised & Ready to Submit-->
<ng-template #otherUI>
  <div *ngIf="apFinalised " class="col-md-12 col-lg-12 m-t-20 p-0">
    <mat-card class="cardWithShadow  shadow-none" style="border: 1px solid #fed7aa !important; background: #fff7ed; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
      <mat-card-content class="p-y-20">
        <div class="row align-items-center">
          <div class="col-md-8">
            <div class="d-flex align-items-center">
              <div style="width: 50px; height: 50px; border-radius: 50%; border: 1px solid #ff9f1f; background: #ffedd5; display: flex; align-items: center; justify-content: center;" class="text-warning">
                <i-tabler name="lock" class="icon-24" style="color: #ea580c;"></i-tabler>
              </div>
              <!--<div>
              <h4>Period Finalised & Ready to Submit</h4>
              <p class="m-y-2">Accounts have been finalised and are now ready to submit</p>
              </div>-->
              <div class="m-l-10">
                <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-x-4">

                  Period Finalised & Ready to Submit
                </h4>
                <div>
                  <h5 class="f-s-14 f-w-600 m-x-4">Accounts have been finalised and are now ready to submit  </h5>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-right lockUnlockRes">
            <div class="d-flex gap-10 justify-content-end custom-cards-trial">
              <button mat-flat-button class="rounded-5" style="border: 1px solid #fdba74; background:#fff;" (click)="UnfreezeAP()">
                <div class="d-flex text-black">
                  <i-tabler class="icon-20 m-r-4 m-t-0" name="lock-open" style="color: #c2410c;"></i-tabler><span class="f-s-14" style="color: #c2410c;">Unlock</span>
                </div>
              </button>
              <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="gotoSubmissions()">
                <div class="d-flex text-black">
                  <!--<i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler>--><span class="f-s-14 text-white">Submit</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>
<!--Period Finalised & Ready to Submit ends-->
<!--Period Submitted-->
<div *ngIf="apFinalised &&  this.UserRoleAccess?.currentAPSubmitStatus != 'Not Submit' && this.UserRoleAccess?.currentAPSubmitStatus  !== 'Failed' ; else otherUI" class="col-md-12 col-lg-12 p-0 m-t-20">
  <mat-card class="cardWithShadow  shadow-none" style="border: 1px solid #A7F3D0 !important; background: #ECFDF5; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
    <mat-card-content class="p-y-20">
      <div class="row align-items-center">
        <div class="col-md-8">
          <div class="d-flex align-items-center">
            <div style="width: 50px; height: 50px; border-radius: 50%; border: 1px solid #9ee9c2; background: #d1fae5; display: flex; align-items: center; justify-content: center; " class="text-warning">
              <i-tabler name="circle-check" class="icon-30" style="color: #059669;"></i-tabler>
            </div>
            <div class="m-l-10">
              <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-x-4">

                Period Submitted
              </h4>
              <div>
                <h5 class="f-s-14 f-w-600 m-x-4">Submitted to Companies House on {{this.UserRoleAccess?.currentAPSubmitDate}}</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 text-right lockUnlockRes">
          <div class="d-flex gap-10 justify-content-end custom-cards-trial">
            <button mat-flat-button color="primary" class="rounded-5 successBtn" (click)="UnlockandAmend()">
              <div class="d-flex">
                <i-tabler class="icon-20 m-r-4 m-t-0" name="reload"></i-tabler><span class="f-s-14">Unlock & Amend Accounts</span>
              </div>
            </button>
          </div>
        </div>
      </div>

    </mat-card-content>
  </mat-card>
</div>
<!--Ends Period Submitted-->




<div class="">
  <div class="row">
    <div class="col-md-4" (click)="showTrusteeRepport()">
      <div class="card-holder tab-title1" [ngClass]="trusteeReport ? 'active' : ''">
        <!--<span class="number-active active">1</span>--> Trustees' Annual Report
      </div>
    </div>
    <div class="col-md-4" (click)="showStatementofRes()">
      <div class="card-holder tab-title2" [ngClass]="(StatementofRes == true) ? 'active' : ''">
        <!--<span class="number-active">2</span>--> Statement of Trustees' Responsibility
      </div>
    </div>
    <div class="col-md-4" (click)="showDeclaration()">
      <div class="card-holder tab-title" [ngClass]="(declaration == true) ? 'active' : ''">
        <!--<span class="number-active">3</span>--> Trustees' Declaration
      </div>
    </div>
  </div>
</div>

<div class="m-t-12 trusteeReport" *ngIf="trusteeReport">

  <div class="col-12 p-0">

    <div class="col-sm-12 col-sm-12 bg-white border-radius10 m-b-10 p-10 p-x-16">
      <div class="d-flex justify-content-between align-items-center">
        <div class="label">
          <p class="f-s-14 m-b-10 m-t-6">The TAR provides stakeholders with important information about your charity activities, achievements, and governance.</p>
          <h4 class="f-s-14">Do you want to include Trustee Annual Report in your Accounts?</h4>
        </div>
        <div class="radio-selection">
          <mat-radio-group aria-label="Select an option" [disabled]="apFinalised||this.ReportType_Method == 'Auditor'" (change)="setVisibility($event)" [(ngModel)]="tarDetails.annualReport_Status">
            <mat-radio-button value='Yes' [checked]="showContent">Yes</mat-radio-button>
            <mat-radio-button value='No' [checked]="!showContent">No</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>

    <!--<mat-card class="" style="margin-bottom: 5px !important;">
      <mat-card-content>

        <p class="f-s-14">The TAR provides stakeholders with important information about your charity activities, achievements, and governence.</p>
        <div class=""> </div>
        <div class="row align-items-start">
          <div class="col-lg-6">
            <h4 class="f-s-14">Do you want to include Trustee Annual Report in your Accounts?</h4>
          </div>
          <div class="col-lg-6 text-left">-->
    <!--<div class="ar d-flex flex-column" style="flex-direction: column;">-->
    <!--<mat-radio-group aria-label="Select an option" (change)="setVisibility($event)" [(ngModel)]="tarDetails.annualReport_Status">
      <mat-radio-button value='Yes' [checked]="showContent">Yes</mat-radio-button>
      <mat-radio-button value='No' [checked]="!showContent">No</mat-radio-button>
    </mat-radio-group>-->
    <!--</div>-->
    <!--</div>
        </div>

      </mat-card-content>
    </mat-card>-->
  </div>

  <div *ngIf="tarDetails.annualReport_Status=='Yes'">
    <mat-card class="m-t-0">
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
        <mat-tab label="Section A">
          <ng-template matTabContent>
            <div class="p-16 b-b-1 justify-content-center align-items-center" style="max-height: 400px; overflow-y: auto; overflow-x: hidden">
              <mat-card-title class="p-x-0 mat-mdc-card-title">
                <h4 class="f-s-26 f-w-700 text-center" style=" background: #10756e; padding: 10px; color: #fff;"> Reference and Administration Details</h4>
              </mat-card-title>

              <mat-card-content class="b-1 m-t-12 p-x-0">
                <fieldset [disabled]="apFinalised">
                  <mat-card-title class="p-x-14 b-b-1 mat-mdc-card-title">
                    <div class="d-flex align-items-center p-y-20">
                      <div class="">
                        <h4 class="f-s-16 primary-color-dark f-w-600 d-block">Charity Information</h4>
                      </div>
                    </div>
                  </mat-card-title>
                  <div class="p-x-14 m-y-10 m-t-20 row">
                    <div class="col-lg-6">
                      <mat-label class="f-s-14 f-w-600 m-b-8 d-block">Charity name</mat-label>
                    </div>
                    <div class="col-lg-6">
                      <mat-form-field appearance="outline" class="w-100 m-b--10">
                        <input matInput name="charity_Name" [(ngModel)]="charityInformation.charity_Name" title="{{charityInformation.charity_Name}}" disabled />
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="p-x-14 m-y-10 row">
                    <div class="col-lg-6">
                      <mat-label class="f-s-14 f-w-600 m-b-8 d-block">Other name the charity is known by</mat-label>
                    </div>
                    <div class="col-lg-6">
                      <mat-form-field appearance="outline" class="w-100 m-b--10">
                        <input matInput name="other_Names" [(ngModel)]="charityInformation.other_Names" (input)="dirty()" title="{{charityInformation.other_Names}}" placeholder="Other name" [disabled]="charityInformation.from_CharityCommission =='yes'" />
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="p-x-14 m-y-10 row">
                    <div class="col-lg-6">
                      <mat-label class="f-s-14 f-w-600 m-b-8 d-block">
                        Registered charity number
                      </mat-label>
                    </div>
                    <div class="col-lg-6">
                      <mat-form-field appearance="outline" class="w-100 m-b--10">
                        <input matInput name="charity_Registration_Number" [(ngModel)]="charityInformation.charity_Registration_Number" disabled placeholder="Charity Registration Number " />
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="p-x-14 m-y-10 row">
                    <div class="col-lg-6">
                      <mat-label class="f-s-14 f-w-600 m-b-8 d-block">
                        Company registration number
                      </mat-label>
                    </div>
                    <div class="col-lg-6">
                      <mat-form-field appearance="outline" class="w-100 m-b--10">
                        <input matInput name="company_Reference_Number" [(ngModel)]="charityInformation.company_Reference_Number" disabled placeholder="Company Reference Number" />
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="p-x-14 m-y-10 row">
                    <div class="col-lg-6">
                      <mat-label class="f-s-14 f-w-600 m-b-8 d-block">
                        Charity's principal address
                      </mat-label>
                    </div>
                    <div class="col-lg-6">
                      <mat-form-field appearance="outline" class="w-100 m-b--10">
                        <input matInput name="addressLine1" [(ngModel)]="charityInformation.addressLine1" disabled placeholder="Address Line 1" />
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="w-100 m-b--10">
                        <input matInput name="addressLine2" [(ngModel)]="charityInformation.addressLine2" disabled placeholder="Address Line 2" />
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="w-100 m-b--10">
                        <input matInput name="addressLine3" [(ngModel)]="charityInformation.addressLine3" disabled placeholder="Address Line 3" />
                      </mat-form-field>
                      <!--<mat-form-field appearance="outline" class="w-100 m-b--10">
                        <input matInput name="addressLine4" [(ngModel)]="charityInformation.addressLine4" disabled placeholder="Address Line 4" />
                      </mat-form-field>-->
                      <div class="row">
                        <div class="col-lg-6">
                          <mat-form-field appearance="outline" class="w-100">
                            <input matInput name="city" [(ngModel)]="charityInformation.city" disabled placeholder="City" />
                          </mat-form-field>
                        </div>
                        <div class="col-lg-6">
                          <mat-form-field appearance="outline" class="w-100">
                            <input matInput name="postcode" [(ngModel)]="charityInformation.postcode" disabled placeholder="Postcode" />
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </mat-card-content>

              <mat-card-content class="b-1 m-t-12 p-x-0">
                <mat-card-title class="p-x-14 b-b-1 mat-mdc-card-title">
                  <div class="d-flex align-items-center p-y-20">
                    <div class="">
                      <h4 class="f-s-16 primary-color-dark f-w-600 d-block">
                        Names of the charity trustees who manage the charity
                      </h4>
                    </div>
                  </div>
                </mat-card-title>
                <div class="p-x-14 m-y-10 row">
                  <div class="table-responsive w-100 m-14" style="border-radius: 6px;">
                    <fieldset [disabled]="apFinalised">
                      <table mat-table [dataSource]="trustees" class="w-100">
                        <ng-container matColumnDef="Trustee Name">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12">Trustee Name</th>
                          <td mat-cell *matCellDef="let trustees">
                            <mat-form-field appearance="outline" class="w-100">
                              <input matInput name="trustee_Name" [(ngModel)]="trustees.trustee_Name" title="{{trustees.trustee_Name}}" type="text" class="text-left" placeholder="" disabled />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Office">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12">Office (if any)</th>
                          <td mat-cell *matCellDef="let trustees">
                            <mat-form-field appearance="outline" class="w-100">
                              <input matInput name="office" placeholder="Office (if any)" [(ngModel)]="trustees.office" type="text" class="text-left" disabled />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="DateAppointed">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12">Date Appointed (Acted if not for whole year)</th>
                          <td mat-cell *matCellDef="let trustees">
                            <mat-form-field appearance="outline" class="w-100" [ngClass]="{'mat-input-error':trustees.rowmsg1}">
                              <!--<input appTextMaskDate matInput [(ngModel)]="trustees.datesActed" [matDatepicker]="picker" />
                              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                              <mat-datepicker #picker></mat-datepicker>-->
                              <input matInput name="datesActed" (blur)="checkdate3($event,trustees)" (dateChange)="checkdate3($event,trustees)" disabled (input)="removevalid3($event,trustees);dirty()" [matDatepicker]="picker20" placeholder="dd/mm/yyyy" class="date-left" appTextMaskDate [(ngModel)]="trustees.datesActed" />
                              <mat-datepicker-toggle matIconSuffix [for]="picker20"></mat-datepicker-toggle>
                              <mat-datepicker #picker20></mat-datepicker>
                            </mat-form-field>
                            <!--<mat-error *ngIf="trustees.datesActed &&(trustees.datesActed < startDate || trustees.datesActed > endDate)">
                              Date Appointed should be on or between Accounting Period Start and End Date
                            </mat-error>-->
                            <mat-error *ngIf="trustees.rowmsg1" class="p-l-12">
                              {{trustees.rowmsg1}}
                            </mat-error>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="DateResigned">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12">Date Resigned (Acted if not for whole year)</th>
                          <td mat-cell *matCellDef="let trustees">
                            <mat-form-field appearance="outline" class="w-100" [ngClass]="{'mat-input-error':trustees.rowmsg2}">
                              <!--<input appTextMaskDate matInput [(ngModel)]="trustees.datesActed" [matDatepicker]="picker" />
                              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                              <mat-datepicker #picker></mat-datepicker>-->
                              <input matInput name="dateActedResigned" (blur)="checkdate4($event,trustees)" (dateChange)="checkdate4($event,trustees)" (input)="removevalid4($event,trustees);dirty()" [matDatepicker]="picker21" placeholder="dd/mm/yyyy" class="date-left" appTextMaskDate [(ngModel)]="trustees.dateActedResigned" [disabled]="apFinalised" />
                              <mat-datepicker-toggle matIconSuffix [for]="picker21"></mat-datepicker-toggle>
                              <mat-datepicker #picker21></mat-datepicker>
                            </mat-form-field>
                            <!--<mat-error *ngIf="trustees.dateActedResigned &&(trustees.dateActedResigned < startDate || trustees.dateActedResigned > endDate)">
                              Date Resigned should be on or between Accounting Period Start and End Date
                            </mat-error>-->
                            <mat-error *ngIf="trustees.rowmsg2" class="p-l-12">
                              {{trustees.rowmsg2}}
                            </mat-error>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Name">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12">
                            Name of person (or body) entitled to appoint trustee (if any)
                          </th>
                          <td mat-cell *matCellDef="let trustees">
                            <mat-form-field appearance="outline" class="w-100">
                              <input matInput name="nameofPerson" appTrim maxlength="40" [(ngModel)]="trustees.nameofPerson" (input)="dirty()" type="text" class="text-left" placeholder="Appoint Trustee (if any)" [disabled]="apFinalised" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="example-first-header-row"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        <tr class="mat-row" *matNoDataRow>
                          <td class="mat-cell text-center " [attr.colspan]="displayedColumns.length">
                            <div class="container-fluid bg-light-primary rounded p-20 f-s-14">
                              No records found
                            </div>
                          </td>
                        </tr>
                      </table>
                    </fieldset>
                  </div>
                </div>
              </mat-card-content>

              <mat-card-content class="b-1 m-t-12 p-x-0">
                <mat-card-title class="p-x-14 b-b-1 mat-mdc-card-title">
                  <div class="d-flex align-items-center p-y-20">
                    <div class="">
                      <h4 class="f-s-16 primary-color-dark f-w-600 d-block">
                        Names of other trustees for the charity, if any, (for example, any custodian trustees)
                      </h4>
                    </div>
                  </div>
                </mat-card-title>
                <div class="p-x-14 m-y-10 row">
                  <div class="table-responsive w-100 m-14" style="border-radius: 6px;" *ngIf="otherTrustees?.length>0">
                    <fieldset [disabled]="apFinalised">
                      <table mat-table [dataSource]="otherTrustees" class="w-100">
                        <ng-container matColumnDef="Name">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12"> Trustee Name </th>
                          <td mat-cell *matCellDef="let trustees let i=index" style="max-width: 30% !important; width: 30% !important;">
                            <mat-form-field appearance="outline" class="w-100" [ngClass]="{'mat-input-error':showValidation1 && !trustees.trustee_Name}">
                              <input name="trustee_Name" matInput appTrim maxlength="40" (input)="dirty()" [(ngModel)]="trustees.trustee_Name" type="text" class="text-left" placeholder="Trustee Name" [disabled]="apFinalised" />
                            </mat-form-field>
                            <mat-error *ngIf="showValidation1 && !trustees.trustee_Name" class="p-x-12">
                              Trustee Name is required
                            </mat-error>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="DateAppointed">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12">Date Appointed (Acted if not for whole year)</th>
                          <td mat-cell *matCellDef="let trustees" style="max-width: 25% !important; width: 25% !important;">
                            <mat-form-field appearance="outline" class="w-100" [ngClass]="{'mat-input-error':trustees.rowmsg1}">
                              <!--<input appTextMaskDate matInput [(ngModel)]="trustees.dateActed" [matDatepicker]="picker" />
                              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                              <mat-datepicker #picker></mat-datepicker>-->
                              <input name="dateActed" matInput (blur)="checkdate1($event,trustees)" (dateChange)="checkdate1($event,trustees)" (input)="removevalid1($event,trustees);dirty()" [matDatepicker]="picker22" class="date-left" placeholder="dd/mm/yyyy" appTextMaskDate [(ngModel)]="trustees.dateActed" [disabled]="apFinalised" />
                              <mat-datepicker-toggle matIconSuffix [for]="picker22"></mat-datepicker-toggle>
                              <mat-datepicker #picker22></mat-datepicker>
                            </mat-form-field>
                            <!--<mat-error *ngIf="trustees.dateActed &&(trustees.dateActed < startDate ||trustees.dateActed > endDate)" class="p-l-12">
                              Date Appointed should be on or between<br> Accounting Period Start and End Date
                            </mat-error>-->
                            <mat-error *ngIf="trustees.rowmsg1 " class="p-l-12">
                              {{trustees.rowmsg1}}
                            </mat-error>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="DateResigned">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12">Date Resigned (Acted if not for whole year)</th>
                          <td mat-cell *matCellDef="let trustees" style="max-width: 25% !important; width: 25% !important;">
                            <mat-form-field appearance="outline" class="w-100" [ngClass]="{'mat-input-error':trustees.rowmsg2}">
                              <!--<input appTextMaskDate matInput [(ngModel)]="trustees.dateActed" [matDatepicker]="picker" />
                              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                              <mat-datepicker #picker></mat-datepicker>-->
                              <input matInput [matDatepicker]="picker23" (blur)="checkdate2($event,trustees)" (dateChange)="checkdate2($event,trustees)" (input)="removevalid2($event,trustees);dirty()" class="date-left" placeholder="dd/mm/yyyy" name="dateActedResigned" appTextMaskDate [(ngModel)]="trustees.dateActedResigned" [disabled]="apFinalised" />
                              <mat-datepicker-toggle matIconSuffix [for]="picker23"></mat-datepicker-toggle>
                              <mat-datepicker #picker23></mat-datepicker>
                            </mat-form-field>
                            <!--<mat-error *ngIf="trustees.dateActedResigned &&(trustees.dateActedResigned < startDate || trustees.dateActedResigned > endDate)" class="p-l-12">
                              Date Resigned should be on or between<br> Accounting Period Start and End Date
                            </mat-error>-->
                            <mat-error *ngIf="trustees.rowmsg2" class="p-l-12">
                              {{trustees.rowmsg2}}
                            </mat-error>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="action" style="max-width: 20% !important; width: 20% !important;">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12 text-center">Action</th>
                          <td mat-cell *matCellDef="let trustees; let i=index" class="text-center">
                            <button mat-flat-button [disabled]="apFinalised" class="bg-none text-center" style="height: 30px;" (click)="DeleteRow(i)" aria-label="Example icon button with a home icon">
                              <i-tabler class="icon-18 m-r-10 text-danger" name="trash"></i-tabler>
                            </button>

                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsOthertrustees" class="example-first-header-row"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsOthertrustees;"></tr>

                      </table>
                    </fieldset>
                  </div>
                  <fieldset [disabled]="apFinalised">

                    <button mat-flat-button class="add-button m-l-16 m-y-10" style="height: 30px;" (click)="AddRow()" [disabled]="!UserRoleAccess?.m1Add">
                      <div class="d-flex align-items-center">
                        <i-tabler class="icon-18 m-r-10" name="plus"></i-tabler><span class="hidemenutext"> Add Trustee</span>
                      </div>
                    </button>
                  </fieldset>
                </div>
              </mat-card-content>

              <mat-card-content class="b-1 m-t-12 p-x-0">
                <mat-card-title class="p-x-14 b-b-1 mat-mdc-card-title">
                  <div class="d-flex align-items-center p-y-20">
                    <div class="">
                      <h4 class="f-s-16 primary-color-dark f-w-600 d-block">
                        Names and addresses of advisers (optional information)
                      </h4>
                    </div>
                  </div>
                </mat-card-title>
                <div class="p-x-14 m-y-10 row">
                  <div class="table-responsive w-100 m-14" style="border-radius: 6px;" *ngIf="optionalAdvisers?.length>0">
                    <fieldset [disabled]="apFinalised">
                      <table mat-table [dataSource]="optionalAdvisers" class="w-100">
                        <ng-container matColumnDef="Type of adviser">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12">Type of Adviser</th>
                          <td mat-cell *matCellDef="let optionalAdvisers let i=index">
                            <mat-form-field appearance="outline" class="w-100 no-subscript" [ngClass]="{'mat-input-error':showValidation2 && !optionalAdvisers.typeOfAdviser}">
                              <mat-select [(ngModel)]="optionalAdvisers.typeOfAdviser" (selectionChange)="optionalAdvisers.advisers_Name = '';optionalAdvisers.address='';showValidation16=false;dirty()" class=" text-left" placeholder="Select Adviser Type" [disabled]="apFinalised">
                                <mat-option *ngFor="let data of advisorTypes" [value]="data">{{ data }}</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-error *ngIf="showValidation2 && !optionalAdvisers.typeOfAdviser" class="p-x-12">
                              Select a Adviser Type
                            </mat-error>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Name">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12"> Adviser Name</th>
                          <td mat-cell *matCellDef="let optionalAdvisers let i=index">
                            <mat-form-field appearance="outline" class="w-100 no-subscript" [ngClass]="{'mat-input-error':showValidation16 && !optionalAdvisers.advisers_Name}">
                              <mat-select [(ngModel)]="optionalAdvisers.advisorsId" class=" text-left" placeholder="Select Adviser Name" (selectionChange)="onAdvisorNameChange(optionalAdvisers.typeOfAdviser, optionalAdvisers.advisorsId, i);dirty()" [disabled]="apFinalised">
                                <mat-option *ngFor="let adv of getAdvisorNamesByType(optionalAdvisers.typeOfAdviser)" [value]="adv.advisorsId">{{ adv.professionalAdvisors_Name }}</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-error *ngIf="showValidation16 && !optionalAdvisers.advisers_Name" class="p-x-12">
                              Select a Adviser Name
                            </mat-error>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Address">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12">Address</th>
                          <td mat-cell *matCellDef="let optionalAdvisers">
                            <mat-form-field appearance="outline" class="w-100">
                              <input name="address" matInput appTrim maxlength="100" [(ngModel)]="optionalAdvisers.address" type="text" class="text-left" disabled placeholder="Address" title="{{optionalAdvisers.address}}" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                          <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-12 text-center">Action</th>
                          <td mat-cell *matCellDef="let trustees let i=index" class="text-center">
                            <button mat-flat-button [disabled]="apFinalised" class="bg-none text-center" style="height: 30px;" (click)="DeleteRow2(i)" aria-label="Example icon button with a home icon">
                              <i-tabler class="icon-18 m-r-10 text-danger" name="trash"></i-tabler>
                            </button>

                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsadvisers" class="example-first-header-row"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsadvisers;"></tr>

                      </table>
                    </fieldset>
                  </div>
                  <fieldset [disabled]="apFinalised">
                    <button mat-flat-button class="add-button m-l-16 m-y-10" style="height: 30px;" (click)="AddRow2()" [disabled]="!UserRoleAccess?.m1Add">
                      <div class="d-flex align-items-center">
                        <i-tabler class="icon-18 m-r-10" name="plus"></i-tabler><span class="hidemenutext"> Add Adviser </span>
                      </div>
                    </button>
                  </fieldset>
                </div>
              </mat-card-content>

              <mat-card-content class="b-1 m-t-12 p-x-0">
                <fieldset [disabled]="apFinalised">
                  <mat-card-title class="p-x-14 b-b-1 mat-mdc-card-title">
                    <div class="d-flex align-items-center p-y-20">
                      <div class="">
                        <h4 class="f-s-16 primary-color-dark f-w-600 d-block">
                          Name of chief executive or names of senior staff members (optional information)
                        </h4>
                      </div>
                    </div>
                  </mat-card-title>
                  <div class="p-x-14 m-y-10 row">
                    <mat-form-field class="example-full-width w-100 m-x-24 mt-16" appearance="outline">
                      <textarea matInput (input)="dirty()" appTrim [(ngModel)]="tarDetails.nameofChiefExecutive" [disabled]="apFinalised" rows="3" class="text-start" placeholder="" maxlength="2500"></textarea>
                    </mat-form-field>
                  </div>
                </fieldset>
              </mat-card-content>


            </div>
            <!--<hr class="m-t-24" style="opacity:0.2" />-->
            <!--<div class="row p-16 m-b-20">

            <div class="col-sm-12 col-md-4">
              <button mat-flat-button   class="bg-warning text-end" (click)="Back()">
                <div class="d-flex text-black">
                  <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black"> Back</span>
                </div>
              </button>
            </div>
            <div class="col-sm-12 col-md-8" align="right">-->
            <!--<button mat-flat-button   class="bgwhite border-light b-1 text-end m-r-10">
              <div class="d-flex text-black">
                <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
              </div>
            </button>-->
            <!--<button mat-flat-button   type="submit" class="bg-success rounded-5" (click)=" goToNextTab()">
                  <div class="d-flex">
                    <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-right"></i-tabler><span class="f-s-14 text-dark">  Next</span>
                  </div>
                </button>
              </div>
            </div>-->
          </ng-template>
        </mat-tab>
        <!--[disabled]="showValidation1 ||showValidation2"-->
        <mat-tab label="Section B" [disabled]="!isSectionAValid1()||isAnyDateInvalid()">

          <ng-template matTabContent>
            <div class="p-16 b-b-1 justify-content-center align-items-center" style="max-height: 400px; overflow-y: auto; overflow-x: hidden">
              <mat-card-title class="p-x-8 mat-mdc-card-title ">
                <h4 class="f-s-26 f-w-700 text-center" style=" background: #10756e; padding: 10px; color: #fff;"> Objectives and Activities</h4>
              </mat-card-title>

              <h4 class="f-s-16 f-w-500 m-t-20 text-left" style="padding: 10px; color: #10756e;">Summary of the purposes of the charity as set out in its governing document </h4>

              <mat-card-content class="m-t-10 p-x-8">
                <fieldset [disabled]="apFinalised" class="p-x-0">
                  <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                    <ngx-editor-menu [editor]="editor2" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                    <ngx-editor [editor]="editor2" [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecC" (ngModelChange)="handleEditorInput($event,'description_SecC')" [placeholder]="'Type here...'"></ngx-editor>
                  </div>
                </fieldset>
              </mat-card-content>

              <h4 class="f-s-16 f-w-500 m-t-0 text-left" style="padding: 10px; color: #10756e;">Summary of the main activities in relation to those purposes for the public benefit, in particular, the activities, projects or services identified in the accounts </h4>

              <mat-card-content class="m-t-10 p-x-8">
                <fieldset [disabled]="apFinalised" class="p-x-0">
                  <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                    <ngx-editor-menu [editor]="editor8" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                    <ngx-editor [editor]="editor8" [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecC_2" (ngModelChange)="handleEditorInput($event,'description_SecC_2')" [placeholder]="'Type here...'"></ngx-editor>
                  </div>
                </fieldset>
              </mat-card-content>

              <h4 class="f-s-16 f-w-500 m-t-0 text-left" style="padding: 10px; color: #10756e;">Statement confirming whether the trustees have had regard to the guidance issued by the Charity Commission on public benefit</h4>

              <mat-card-content class="m-t-10 p-x-8">
                <fieldset [disabled]="apFinalised" class="p-x-0">
                  <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                    <ngx-editor-menu [editor]="editor9" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                    <ngx-editor [editor]="editor9" [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecC_3" (ngModelChange)="handleEditorInput($event,'description_SecC_3')" [placeholder]="'Type here...'"></ngx-editor>
                  </div>
                </fieldset>
              </mat-card-content>


              <h4 class="f-s-16 f-w-500 m-t-0 text-left" style="padding: 10px; color: #10756e;">Additional Information </h4>
              <mat-card-content class="m-t-10 p-x-8">
                <fieldset [disabled]="apFinalised" class="p-x-0">
                  <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                    <ngx-editor-menu [editor]="editor10" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                    <ngx-editor [editor]="editor10" [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecC_4" (ngModelChange)="handleEditorInput($event,'description_SecC_4')" [placeholder]="'Type here...'"></ngx-editor>
                  </div>
                </fieldset>
              </mat-card-content>

            </div>
            <!--<hr class="m-t-24" style="opacity:0.2" />
            <div class="row p-16 m-b-20">

              <div class="col-sm-12 col-md-4">
                <button mat-flat-button   class="bg-warning text-end" (click)="goToPreviousTab()">
                  <div class="d-flex text-black">
                    <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black"> Back</span>
                  </div>
                </button>
              </div>
              <div class="col-sm-12 col-md-8" align="right">-->
            <!--<button mat-flat-button   class="bgwhite border-light b-1 text-end m-r-10">
              <div class="d-flex text-black">
                <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
              </div>
            </button>-->
            <!--<button mat-flat-button   class="bg-success rounded-5" (click)="goToNextTab()">
                  <div class="d-flex">
                    <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-right"></i-tabler><span class="f-s-14 text-dark">  Next</span>
                  </div>
                </button>
              </div>
            </div>-->
          </ng-template>
        </mat-tab>

        <mat-tab label="Section C" [disabled]="!isSectionAValid1()||isAnyDateInvalid()">
          <ng-template matTabContent>
            <div class="p-16 b-b-1 justify-content-center align-items-center" style="max-height: 400px; overflow-y: auto; overflow-x: hidden">
              <mat-card-title class="p-x-8 mat-mdc-card-title ">
                <h4 class="f-s-26 f-w-700 text-center" style=" background: #10756e; padding: 10px; color: #fff;"> Achievements and Performance</h4>
              </mat-card-title>

              <h4 class="f-s-16 f-w-500 m-t-20 text-left" style="padding: 10px; color: #10756e;">Summary of the main achievements of the charity, identifying the difference the charity’s work has made to the circumstances of its beneficiaries and any wider benefits to society as a whole</h4>


              <mat-card-content class="m-t-10 p-x-8">

                <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                  <fieldset [disabled]="apFinalised" class="p-x-0">
                    <ngx-editor-menu [editor]="editor3" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                    <ngx-editor [editor]="editor3" [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecD" (ngModelChange)="handleEditorInput($event,'description_SecD')" [disabled]="false" [placeholder]="'Type here...'"></ngx-editor>
                  </fieldset>
                </div>
              </mat-card-content>
            </div>

            <!--<hr class="m-t-24" style="opacity:0.2" />
            <div class="row p-16 m-b-20">

              <div class="col-sm-12 col-md-4">
                <button mat-flat-button   class="bg-warning text-end" (click)="goToPreviousTab()">
                  <div class="d-flex text-black">
                    <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black"> Back</span>
                  </div>
                </button>
              </div>
              <div class="col-sm-12 col-md-8" align="right">-->
            <!--<button mat-flat-button   class="bgwhite border-light b-1 text-end m-r-10">
              <div class="d-flex text-black">
                <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
              </div>
            </button>-->
            <!--<button mat-flat-button   class="bg-success rounded-5" (click)="goToNextTab()">
                  <div class="d-flex">
                    <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-right"></i-tabler><span class="f-s-14 text-dark">  Next</span>
                  </div>
                </button>
              </div>
            </div>-->
          </ng-template>
        </mat-tab>

        <mat-tab label="Section D" [disabled]="!isSectionAValid1()||isAnyDateInvalid()">
          <ng-template matTabContent>
            <div class="p-16 b-b-1  justify-content-center align-items-center" style="max-height: 400px; overflow-y: auto; overflow-x: hidden">
              <mat-card-title class="p-x-8 mat-mdc-card-title ">
                <h4 class="f-s-26 f-w-700 text-center" style=" background: #10756e; padding: 10px; color: #fff;"> Financial Review</h4>
              </mat-card-title>

              <h4 class="f-s-16 f-w-500 m-t-20 text-left" style="padding: 10px; color: #10756e;">Review of the charity’s financial position at the end of the period</h4>


              <mat-card-content class="m-t-10 p-x-8">

                <!--<div class="NgxEditor__Wrapper" style="min-height: 300px;">
                  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                  <ngx-editor [editor]="editor" [ngModel]="tarDetails.description_SecE" [disabled]="false" [placeholder]="'Type here...'"></ngx-editor>
                </div>-->
                <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                  <fieldset [disabled]="apFinalised" class="p-x-0">
                    <ngx-editor-menu [editor]="editor4" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                    <ngx-editor [editor]="editor4" [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecE" (ngModelChange)="handleEditorInput($event,'description_SecE')" [disabled]="false" [placeholder]="'Type here...'"></ngx-editor>
                  </fieldset>
                </div>
              </mat-card-content>


              <h4 class="f-s-16 f-w-500 m-t-20 text-left" style="padding: 10px; color: #10756e;">Statement explaining the policy for holding reserves stating why they are held</h4>

              <mat-card-content class="m-t-10 p-x-8">
                <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                  <fieldset [disabled]="apFinalised" class="p-x-0">
                    <ngx-editor-menu [editor]="editor11" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                    <ngx-editor [editor]="editor11" [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecE_2" (ngModelChange)="handleEditorInput($event,'description_SecE_2')" [disabled]="false" [placeholder]="'Type here...'"></ngx-editor>
                  </fieldset>
                </div>
              </mat-card-content>

              <div class="col-12 p-r-8 p-l-0">
                <div class="row align-items-center m-t-20 m-b-8">
                  <div class="col-lg-6">
                    <h4 class="f-s-16 f-w-500 text-left" style="padding: 10px; color: #10756e;">Amount of reserves held (£)</h4>
                  </div>
                  <div class="col-lg-6">
                    <fieldset [disabled]="apFinalised" class="p-x-0">
                      <mat-form-field appearance="outline" class="hide-hint w-100">
                        <!--<input matInput type="text" [(ngModel)]="tarDetails.description_SecE_3" (input)="limitDecimal($event)" class="text-right" />-->

                        <input matInput type="text" [(ngModel)]="tarDetails.description_SecE_3" (input)="onDecimalInput($event, 'description_SecE_3')" class="text-right" />

                      </mat-form-field>
                    </fieldset>
                  </div>
                </div>
              </div>

              <!--<mat-card-content class="m-t-10 p-x-8">
                <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                  <ngx-editor-menu [editor]="editor12" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                  <ngx-editor [editor]="editor12" [(ngModel)]="tarDetails.description_SecE_3" (ngModelChange)="handleEditorInput($event,'description_SecE_3')" [disabled]="false" [placeholder]="'Type here...'"></ngx-editor>
                </div>
              </mat-card-content>-->

              <h4 class="f-s-16 f-w-500 m-t-20 text-left" style="padding: 10px; color: #10756e;">Reasons for holding zero reserves </h4>

              <mat-card-content class="m-t-10 p-x-8">
                <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                  <fieldset [disabled]="apFinalised" class="p-x-0">
                    <ngx-editor-menu [editor]="editor13" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                    <ngx-editor [editor]="editor13" [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecE_4" (ngModelChange)="handleEditorInput($event,'description_SecE_4')" [disabled]="false" [placeholder]="'Type here...'"></ngx-editor>
                  </fieldset>
                </div>
              </mat-card-content>


              <div class="col-12 p-r-8 p-l-0">
                <div class="row align-items-center m-t-20 m-b-8">
                  <div class="col-lg-6">
                    <h4 class="f-s-16 f-w-500 m-t-20 text-left" style="padding: 10px; color: #10756e;">Details of fund materially in deficit (£)</h4>
                  </div>
                  <div class="col-lg-6">
                    <fieldset [disabled]="apFinalised" class="p-x-0">
                      <mat-form-field appearance="outline" class="hide-hint w-100">
                        <!--<input matInput type="text" [(ngModel)]="tarDetails.description_SecE_5" (input)="limitDecimal($event)" class="text-right" />-->
                        <input matInput type="text" [(ngModel)]="tarDetails.description_SecE_5" (input)="onDecimalInput($event, 'description_SecE_5')" class="text-right" />
                      </mat-form-field>
                    </fieldset>
                  </div>
                </div>
              </div>

              <!--<mat-card-content class="m-t-10 p-x-8">
                <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                  <ngx-editor-menu [editor]="editor14" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                  <ngx-editor [editor]="editor14" [(ngModel)]="tarDetails.description_SecE_5" (ngModelChange)="handleEditorInput($event,'description_SecE_5')" [disabled]="false" [placeholder]="'Type here...'"></ngx-editor>
                </div>
              </mat-card-content>-->

              <h4 class="f-s-16 f-w-500 m-t-20 text-left" style="padding: 10px; color: #10756e;">Explanation of any uncertainties about the charity continuing as a going concern</h4>

              <mat-card-content class="m-t-10 p-x-8">
                <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                  <fieldset [disabled]="apFinalised" class="p-x-0">
                    <ngx-editor-menu [editor]="editor15" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                    <ngx-editor [editor]="editor15" [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecE_6" (ngModelChange)="handleEditorInput($event,'description_SecE_6')" [disabled]="false" [placeholder]="'Type here...'"></ngx-editor>
                  </fieldset>
                </div>
              </mat-card-content>

            </div>
            <!--<hr class="m-t-24" style="opacity:0.2" />-->
            <!--<div class="row p-16 m-b-20">

            <div class="col-sm-12 col-md-4">
              <button mat-flat-button   class="bg-warning text-end" (click)="goToPreviousTab()">
                <div class="d-flex text-black">
                  <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black"> Back</span>
                </div>
              </button>
            </div>
            <div class="col-sm-12 col-md-8" align="right">-->
            <!--<button mat-flat-button   class="bgwhite border-light b-1 text-end m-r-10">
              <div class="d-flex text-black">
                <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
              </div>
            </button>-->
            <!--<button mat-flat-button   class="bg-success rounded-5" (click)="goToNextTab()">
                  <div class="d-flex">
                    <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-right"></i-tabler><span class="f-s-14 text-dark">  Next</span>
                  </div>
                </button>
              </div>
            </div>-->
          </ng-template>
        </mat-tab>

        <mat-tab label="Section E" [disabled]="!isSectionAValid1()||isAnyDateInvalid()">
          <ng-template matTabContent>
            <div class="p-16 b-b-1 justify-content-center align-items-center" style="max-height: 400px; overflow-y: auto; overflow-x: hidden">
              <mat-card-title class="p-x-0 mat-mdc-card-title ">
                <h4 class="f-s-26 f-w-700 text-center" style=" background: #10756e; padding: 10px; color: #fff;"> Structure, Governance and Management</h4>
              </mat-card-title>

              <h4 class="f-s-16 f-w-500 m-t-20 text-left" style="padding: 10px 0px ; color: #10756e;">Type of governing document   </h4>

              <mat-card-content class="m-t-10 p-x-0">
                <fieldset [disabled]="apFinalised" class="p-x-0">
                  <div class="NgxEditor__Wrapper" style="min-height: 220px;">
                    <ngx-editor-menu [editor]="editor1" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                    <ngx-editor [editor]="editor1" [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecB" (ngModelChange)="handleEditorInput($event,'description_SecB')" [disabled]="false" [placeholder]="'Type here...'"></ngx-editor>
                  </div>
                </fieldset>


              </mat-card-content>

              <h4 class="f-s-16 f-w-500 m-t-20 text-left" style="padding: 10px 0px; color: #10756e;">Trustee selection methods including details of any constitutional provisions e.g. election to post or name of any person or body entitled to appoint one or more trustees </h4>

              <mat-card-content class="m-t-10 p-x-0">
                <fieldset [disabled]="apFinalised" class="p-x-0">
                  <div class="NgxEditor__Wrapper" style="min-height: 220px;">
                    <ngx-editor-menu [editor]="editor6" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                    <ngx-editor [editor]="editor6" [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecB_2" (ngModelChange)="handleEditorInput($event,'description_SecB_2')" [disabled]="false" [placeholder]="'Type here...'"></ngx-editor>
                  </div>
                </fieldset>


              </mat-card-content>

              <h4 class="f-s-16 f-w-500 m-t-20 text-left" style="padding: 10px 0px; color: #10756e;">Additional information</h4>

              <mat-card-content class="m-t-10 p-x-0">
                <fieldset [disabled]="apFinalised" class="p-x-0">
                  <div class="NgxEditor__Wrapper" style="min-height: 220px;">
                    <ngx-editor-menu [editor]="editor7" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                    <ngx-editor [editor]="editor7" [disabled]="apFinalised" [(ngModel)]="tarDetails.description_SecB_3" (ngModelChange)="handleEditorInput($event,'description_SecB_3')" [disabled]="false" [placeholder]="'Type here...'"></ngx-editor>
                  </div>
                </fieldset>


              </mat-card-content>


            </div>

          </ng-template>
        </mat-tab>

      </mat-tab-group>

    </mat-card>
  </div>
  <hr class="m-t-24" style="opacity:0.2" *ngIf="tarDetails.annualReport_Status!='No'" />
  <div class="row p-16 m-b-8">

    <div class="col-6 col-sm-6 col-md-4">
      <button mat-flat-button class="bg-warning text-end" (click)="goToPreviousTab()">
        <div class="d-flex text-black">
          <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black hidemenutext"> Back</span>
        </div>
      </button>
    </div>
    <div class="col-6 col-sm-6 col-md-8" align="right">
      <!--<button mat-flat-button   class="bgwhite border-light b-1 text-end m-r-10">
        <div class="d-flex text-black">
          <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
        </div>
      </button>-->
      <button mat-flat-button type="submit" class="bg-success rounded-5" (click)="goToNextTab('yes')" *ngIf="tarDetails.annualReport_Status!='No'">
        <div class="d-flex">
          <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-right"></i-tabler><span class="f-s-14 text-dark hidemenutext"> Next</span>
        </div>
      </button>
      <button mat-flat-button type="submit" class="bg-success rounded-5" (click)="goToNextTab('no')" *ngIf="tarDetails.annualReport_Status=='No'">
        <div class="d-flex">
          <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-right"></i-tabler><span class="f-s-14 text-dark hidemenutext"> Next</span>
        </div>
      </button>
    </div>
  </div>

</div>

<div class="m-t-12 StatementofRes" *ngIf="StatementofRes">

  <div class="col-12 p-0 m-t-12">

    <div class="col-sm-12 col-sm-12 bg-white border-radius10 m-b-10 p-10 p-x-16">
      <div class="d-flex justify-content-between align-items-center">
        <div class="label">
          <p class="f-s-14 m-b-10 m-t-6">The trustees are responsible for providing stakeholders with accurate information regarding the charity’s activities, achievements, and governance.</p>
          <h4 class="f-s-14">Do you want to include Statement of Trustees’ Responsibility in your Accounts?</h4>
        </div>
        <div class="radio-selection">
          <mat-radio-group aria-label="Select an option" (change)="setVisibility1($event)" [(ngModel)]="statementofTrusteesModal.includeTAR" [disabled]="apFinalised">
            <mat-radio-button value='Yes' [checked]="showContent1">Yes</mat-radio-button>
            <mat-radio-button value='No' [checked]="!showContent1">No</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>

    <!--<mat-card class="">
      <mat-card-content>
        <p class="f-s-14">The trustees are responsible for providing stakeholders with accurate information regarding the charity’s activities, achievements, and governance.</p>
        <div class=""> </div>
        <div class="row align-items-start">
          <div class="col-lg-6">
            <h4 class="f-s-14">Do you want to include Statement of Trustees’ Responsibility in your Accounts?</h4>
          </div>
          <div class="col-lg-6 text-left">
            <div class="ar d-flex flex-column" style="">-->
    <!--<mat-radio-button value='Yes' [checked]="showContent" (change)="setVisibility1($event)">Yes</mat-radio-button>
    <mat-radio-button value='No' [checked]="!showContent" (change)="setVisibility1($event)">No</mat-radio-button>-->
    <!--<mat-radio-group aria-label="Select an option" (change)="setVisibility1($event)" [(ngModel)]="statementofTrusteesModal.includeTAR">
              <mat-radio-button value='Yes' [checked]="showContent1">Yes</mat-radio-button>
              <mat-radio-button value='No' [checked]="!showContent1">No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>

    </mat-card-content>-->
    <!--<mat-card-content>
      <p class="f-s-14">
        The TAR provides stakeholders with important information about your charity's activities, achievements, and governance.
      </p>

      <div class="row align-items-start">
        <div class="col-lg-6">
          <h4 class="f-s-14">Do you want to include Trust Annual Report in your Accounts?</h4>
        </div>

        <div class="col-lg-6 text-left">
          <mat-radio-group [(ngModel)]="selectedReportOption" (change)="setVisibility($event)">
            <mat-radio-button value="yes">Yes</mat-radio-button>
            <mat-radio-button value="no">No</mat-radio-button>
          </mat-radio-group>

        </div>
      </div>
    </mat-card-content>-->
    <!--</mat-card>-->
  </div>


  <mat-card *ngIf="statementofTrusteesModal.includeTAR=='Yes'">
    <fieldset [disabled]="apFinalised">
      <mat-card-content class="p-0">
        <div style="max-height: 460px; overflow-y: auto; overflow-x: hidden">
          <div>
            <mat-card-content class="p-0 bg-white" style="border-radius: 12px;">
              <div class="p-16 p-b-0 justify-content-center align-items-center">

                <!-- Rich Text Editor -->
                <mat-card-content class="bg-white m-t-0 p-x-0 p-t-0">
                  <div class="p-b-10 d-flex justify-content-end">
                    <button mat-flat-button (click)="SetDefault()" class="bg-none text-primary" style="height: 30px;" [disabled]="!UserRoleAccess?.m1Create">
                      <span class=""> Default Statement </span>
                    </button>
                  </div>
                  <!--<div class="NgxEditor__Wrapper" style="min-height: 220px;">
                    <ngx-editor-menu [editor]="editor16"  [toolbar]="toolbar"></ngx-editor-menu>
                    <ngx-editor [editor]="editor16"
                                  [(ngModel)]="responsibilties.trusteeStatement"
                                (ngModelChange)="handleEditorInput($event,'trusteeStatement')"
                                placeholder="Type here...">
                    </ngx-editor>
                  </div>-->
                  <div class="NgxEditor__Wrapper" style="min-height: 220px;">
                    <ngx-editor-menu [editor]="editor16" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                    <ngx-editor [editor]="editor16" [disabled]="apFinalised" [(ngModel)]="statementofTrusteesModal.trusteeStatement" (ngModelChange)="handleEditorInput($event,'trusteeStatement')" [disabled]="false" [placeholder]="'Type here...'"></ngx-editor>

                  </div>
                </mat-card-content>
              </div>
            </mat-card-content>
          </div>



        </div>

      </mat-card-content>
    </fieldset>
  </mat-card>
  <hr class="m-t-16" style="opacity:0.2" *ngIf="statementofTrusteesModal.includeTAR=='Yes'" />
  <div class="row p-16 p-b-0 m-b-0">

    <div class="col-6 col-sm-6 col-md-4 m-b-16">
      <button mat-flat-button class="bg-warning text-end" (click)="showTrusteeRepport()">
        <div class="d-flex text-black">
          <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black hidemenutext"> Back</span>
        </div>
      </button>
    </div>
    <div class="col-6 col-sm-6 col-md-8 m-b-16" align="right">
      <!--<button mat-flat-button   class="bgwhite border-light b-1 text-end m-r-10">
        <div class="d-flex text-black">
          <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
        </div>
      </button>-->
      <button mat-flat-button class="bg-success rounded-5" (click)="showDeclaration()" [disabled]="!UserRoleAccess?.m1View">
        <div class="d-flex">
          <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-right"></i-tabler><span class="f-s-14 text-dark hidemenutext">Next</span>
        </div>
      </button>
    </div>
  </div>
</div>

<div class="m-t-12 declaration" *ngIf="declaration">

  <mat-card>
    <mat-card-content class="p-0 p-b-12">
      <fieldset [disabled]="apFinalised || isDeclarationDisabled()">
        <div class="col-12">
          <mat-card-content class="b-1 m-t-12 p-0">
            <mat-card-title class="p-x-14 b-b-1 mat-mdc-card-title" style="background: #e6f1f0;">
              <div class="d-flex align-items-center p-y-20">
                <div class="icon-holder">
                  <i-tabler class="icon-24 m-r-0 primary-color-dark" name="circle-check"></i-tabler>
                </div>
                <div class="">
                  <h4 class="f-s-16 primary-color-dark f-w-600 d-block">Trustee Declaration</h4>
                  <p class="f-s-14 m-0">Approve and sign the report on behalf of the board of trustees.</p>
                </div>
              </div>
            </mat-card-title>
            <div class="p-x-14 m-y-10 row">
              <div class="col-lg-6">
                <mat-label class="f-s-14 f-w-600 m-b-8 d-block m-t-12">
                  <div class="d-flex align-items-center">
                    <i-tabler class="icon-20 m-r-10 primary-color-dark" name="user"></i-tabler>
                    <h5 class="f-w-600 f-s-14">
                      Approved by Trustee <span class="text-error">*</span>
                    </h5>
                  </div>
                </mat-label>
                <mat-form-field appearance="outline" class="w-100 no-subscript" [ngClass]="{'mat-input-error':showValidation3 && !tarDetails.approvedbyTrustee_SecA}">
                  <mat-select (selectionChange)="dirty()" [(ngModel)]="tarDetails.approvedbyTrustee_SecA" placeholder="Select Trustee" [disabled]="apFinalised ||isDeclarationDisabled()">
                    <mat-option *ngFor="let data of trustees" [value]="data.truste_Id">{{ data.trustee_Name }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-error *ngIf="showValidation3 && !tarDetails.approvedbyTrustee_SecA" class="p-x-12">
                  Select a Trustee
                </mat-error>
              </div>
              <div class="col-lg-6">
                <mat-label class="f-s-14 f-w-600 m-b-8 d-block m-t-12">
                  <div class="d-flex align-items-center">
                    <i-tabler class="icon-24 m-r-10 primary-color-dark" name="calendar"></i-tabler>
                    <h5 class="f-w-600 f-s-14">
                      Approval Date <span class="text-error">*</span>
                    </h5>
                  </div>
                </mat-label>
                <mat-form-field appearance="outline" class="w-100 no-subscript" [ngClass]="{'mat-input-error':(showValidation4 && !tarDetails.approvalDate_SecA)||tarDetails.rowmsg}">
                  <input matInput [disabled]="apFinalised" (blur)="checkdate($event,tarDetails)" (dateChange)="checkdate($event,tarDetails)" (input)="removevalid($event,tarDetails);dirty()" [matDatepicker]="picker3" class="date-left" placeholder="dd/mm/yyyy" appTextMaskDate [(ngModel)]="tarDetails.approvalDate_SecA" />
                  <mat-datepicker-toggle matIconSuffix [for]="picker3"></mat-datepicker-toggle>
                  <mat-datepicker #picker3></mat-datepicker>
                </mat-form-field>
                <mat-error *ngIf="tarDetails.rowmsg" class="p-l-12">
                  {{tarDetails.rowmsg}}
                </mat-error>
                <mat-error *ngIf="showValidation4 && !tarDetails.approvalDate_SecA && !tarDetails.rowmsg" class="p-x-12">
                  Approval Date is required
                </mat-error>
              </div>
              <!--show below section dynamic while choosing Trustee-->
              <div class="col-lg-12 d-none">
                <div class="rounded-2 b-1 p-14 m-y-6" style="border-radius: 6px; background: #e6f1f0;">
                  <p class="f-s-14 primary-color-dark">
                    The Trustees' annual report was approved on {{tarDetails.approvalDate_SecA}} and signed on behalf of the board of trustees by: {{tarDetails.approvedbyTrustee_SecA}}
                  </p>
                </div>
              </div>
            </div>
          </mat-card-content>
        </div>
      </fieldset>

    </mat-card-content>
  </mat-card>
  <hr class="m-t-24" style="opacity:0.2" />
  <div class="row p-16">

    <div class="col-6 col-sm-6 col-md-4 m-b-16">
      <button mat-flat-button class="bg-warning text-end" (click)="showStatementofRes()">
        <div class="d-flex text-black">
          <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black hidemenutext"> Back</span>
        </div>
      </button>
    </div>
    <div class="col-6 col-sm-6 col-md-8 m-b-16" align="right">
      <!--<button mat-flat-button   class="bgwhite border-light b-1 text-end m-r-10">
        <div class="d-flex text-black">
          <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
        </div>
      </button>-->
      <button mat-flat-button class="bg-success rounded-5" (click)="SaveTar()" [disabled]="!UserRoleAccess?.m1View">
        <div class="d-flex">
          <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-right"></i-tabler><span class="f-s-14 text-dark hidemenutext">Next</span>
        </div>
      </button>
    </div>
  </div>
</div>
